import { createApi } from '@reduxjs/toolkit/query/react';
import { getBaseQuery } from './getBaseQuery';
import { DeleteHorizonRequest, DeleteHorizonResponse, DuplicateHorizonRequest, DuplicateHorizonResponse, GetHorizonRequest, GetHorizonResponse, GetHorizonSelectorRequest, GetHorizonSelectorResponse, GetHorizonUuidRequest, GetHorizonUuidResponse, PatchHorizonRequest, PatchHorizonResponse, PostHorizonRequest, PostHorizonResponse } from './types/THorizonServices';

const URL_Prefix = '/horizon';

export const horizonService = createApi({
    reducerPath: 'horizonService',
    baseQuery: getBaseQuery,
    tagTypes: ['Horizon'],
    endpoints: (builder) => ({
        getHorizon: builder.query<GetHorizonResponse, GetHorizonRequest>({
            query: (params) => ({
                url: `${URL_Prefix}/`,
                method: 'GET',
                params: params,
            }),
        }),
        postHorizon: builder.mutation<PostHorizonResponse, PostHorizonRequest>({
            query: (body) => ({
                url: `${URL_Prefix}/`,
                method: 'POST',
                body: body
            }),
            invalidatesTags: ['Horizon'],
        }),
        patchHorizon: builder.mutation<PatchHorizonResponse, PatchHorizonRequest>({
            query: (body) => ({
                url: `${URL_Prefix}/${body.uuid}/`,
                method: 'PATCH',
                body: body
            }),
            invalidatesTags: ['Horizon'],
        }),
        getHorizonUuid: builder.query<GetHorizonUuidResponse, GetHorizonUuidRequest>({
            query: (params) => ({
                url: `${URL_Prefix}/${params.uuid}/`,
                method: 'GET',
                params: params,
            }),
        }),
        duplicateHorizon: builder.mutation<DuplicateHorizonResponse, DuplicateHorizonRequest>({
            query: (body) => ({
                url: `${URL_Prefix}/${body.uuid}/duplicate/`,
                method: 'POST',
                body: body
            }),
            invalidatesTags: ['Horizon'],
        }),
        getHorizonSelector: builder.query<GetHorizonSelectorResponse, GetHorizonSelectorRequest>({
            query: (params) => ({
                url: `${URL_Prefix}/selector/`,
                method: 'GET',
                params: params,
            }),
        }),
        deleteHorizon: builder.mutation<DeleteHorizonResponse, DeleteHorizonRequest>({
            query: (body) => ({
                url: `${URL_Prefix}/${body.uuid}/cascade/`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Horizon'],
        }),
    }),
});

// Экспортируем все хуки, включая useLazySendCodeQuery
export const {
    useGetHorizonQuery,
    useLazyGetHorizonQuery,
    usePostHorizonMutation,
    useGetHorizonUuidQuery,
    useLazyGetHorizonUuidQuery,
    usePatchHorizonMutation,
    useDuplicateHorizonMutation,
    useGetHorizonSelectorQuery,
    useLazyGetHorizonSelectorQuery,
    useDeleteHorizonMutation
} = horizonService;